import React from 'react';
import WizardItem, { IWizardItem } from '../WizardItem';
import VStack from '../../../../BaseModule/Components/VStack/Vstack';

interface Props {
	item: IWizardItem;
}

const WizardVStack: React.FC<Props> = ({ item }) => {
	const settings = item.settings;
	const style: React.CSSProperties = {
		...(settings?.style ?? {}),
		gap: settings?.gap ?? '0px',
	};

	if (item?.children?.length) {
		return (
			<VStack style={style}>
				{item.children.map((child, key) => (
					<React.Fragment key={key}>
						<WizardItem item={child} />
					</React.Fragment>
				))}
			</VStack>
		);
	}

	return <></>;
};

export default WizardVStack;
